import React from 'react'
import './styles/badge.scss'

const Badge = (props) => {
    const {
        children, cssClass, isRounded, type, style, label, icon,
    } = props

    let componentClass = 'uc-badge'
    componentClass += isRounded ? ' rounded' : ''
    componentClass += icon ? ' iconBadge' : ''
    componentClass += type ? ` ${type}` : ''
    componentClass += cssClass ? ` ${cssClass}` : ''

    return (
        <span className={componentClass} style={style}>
            {label}
            {icon ? <i className={icon} /> : null}
            {children}
        </span>
    )
}

export default Badge
